import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import keyUpHandler from '../../utils/keyUpHandler'

import { subscriptionBannerSelector } from '../../../redux/modules/subscriptions/selectors'

import './styles.css'

// The page's top padding follows the banner's real height (its text wraps
// to two lines at common widths) through this variable; absent when the
// banner isn't rendered, so the page keeps its usual padding then.
const HEIGHT_VAR = '--subscription-banner-height'

function SubscriptionBanner(props) {
  const rootRef = useRef(null)

  useEffect(() => {
    const el = rootRef.current
    const root = document.documentElement
    if (!el) {
      root.style.removeProperty(HEIGHT_VAR)
      return undefined
    }
    const publish = () => root.style.setProperty(HEIGHT_VAR, `${el.offsetHeight}px`)
    publish()
    const observer =
      typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(publish)
    if (observer) observer.observe(el)
    return () => {
      if (observer) observer.disconnect()
      root.style.removeProperty(HEIGHT_VAR)
    }
  })

  useEffect(() => {
    if (
      props.bannerSubscriptionIsReady &&
      props.location &&
      props.location.pathname
    )
      if (
        props.location.pathname === '/' ||
        location.pathname.startsWith('/subscriptions/plans') ||
        location.pathname.startsWith('/checkout')
      )
        props.onClose()
  }, [props.location, props.bannerSubscriptionIsReady])

  const {
    subscriptionBannerText,
    subscriptionBannerButtonText,
    subscriptionBannerButtonUrl
  } = props.subscriptionPlansLanguage

  if (props.hasSubscription) return null

  if (
    subscriptionBannerText &&
    subscriptionBannerButtonUrl &&
    subscriptionBannerButtonText &&
    props.bannerSubscriptionIsReady
  )
    return (
      <div
        id="SubscriptionBanner"
        ref={rootRef}
        className={`${props.isMobile ? 'is-mobile' : ''} ${
          props.userIsAuthenticated && !props.userIsVerified
            ? 'user-not-verified'
            : ''
        } ${props.underTopBanner ? 'under-top-banner' : ''}`}
      >
        <div className="wrapper">
          <span className="banner-text">{subscriptionBannerText}</span>
          <a
            className="banner-button btn -small -border-orange"
            href={subscriptionBannerButtonUrl}
          >
            <span>{subscriptionBannerButtonText}</span>
          </a>
          <button
            onClick={() => props.onClose()}
            onKeyUp={(event) => keyUpHandler(event, props.onClose)}
            tabIndex="0"
            type="button"
            className="banner-close-icon"
          >
            <i aria-label="Close" className="icon-close" />
          </button>
        </div>
      </div>
    )
  return null
}

export default connect(subscriptionBannerSelector, null)(SubscriptionBanner)
